/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Cancel_TitleInputs */



/**
* | output |
* | --- |
* | "Cancel this round?" |
*
* @param {Rounds_Cancel_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_cancel_title = /** @type {((inputs?: Rounds_Cancel_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Cancel_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler cette ronde ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Cancelar esta ronda?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cancelar esta rodada?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annullare questo round?")
	return /** @type {LocalizedString} */ ("Cancel this round?")
});